import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { useGetVehicleInfo } from "../../../../../queries/useGetVehicleInfo";
import { SeasonNumber } from "../../../../../queries/useGetVehicleInfoByVehicleKeys";
import { useDealerAccountInfo } from "../../../../../stores/hooks/useDealerAccountInfo";
import { useTireResults } from "../../useTireResults";

export const useSeasonList = (): SeasonOption[] => {
  const { t } = useTranslation();
  const { data: keys } = useGetVehicleInfo();
  const { dealerProductFilters } = useDealerAccountInfo();
  const { data: tireResults } = useTireResults();

  const seasonList = useMemo(
    () =>
      (
        tireResults?.partListSummary?.seasonList.filter(({ partCount }) =>
          Boolean(partCount)
        ) ||
        keys?.partListSummary?.seasonList ||
        Object.keys(dealerProductFilters.seasonCodes).map((season) => ({
          season: Number(season) as SeasonNumber,
        }))
      )
        .map<SeasonOption>(({ season }) => ({
          name: t(`season.${season}`),
          value: season,
        }))
        .sort((a, b) => Math.abs(a.value - 1) - Math.abs(b.value - 1)),
    [keys, dealerProductFilters, t]
  );
  return seasonList;
};

type SeasonOption = {
  name: string;
  value: SeasonNumber;
};
